export {
  fetchProduct,
  watchFetchProduct
} from './productActions';